import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VModal from 'vue-js-modal';
// import VueGtag from 'vue-gtag';
// import mixinModal from './mixins/modal';
import store from './store';
import AppJobOffer from './AppJobOffer.vue';
// import AppInterview from './AppInterview.vue';
// import AppNews from './AppNews.vue';
// import AppBanner from './AppBanner.vue';
/**
 * Register
 */
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(VModal);
// Vue.mixin(mixinModal);
// Vue.use(VueGtag, {
//   config: { id: 'UA-148359085-1' }
// });
/**
 * Initialize
 */
new Vue({
  store,
  render: h => h(AppJobOffer)
}).$mount('#app-jobOffer');
// 初期リリースでは使用しない。必要になったら開発を切る
// new Vue({
//   store,
//   render: h => h(AppInterview)
// }).$mount('#app-interview');
// new Vue({
//   store,
//   render: h => h(AppNews)
// }).$mount('#app-news');
// new Vue({
//   store,
//   render: h => h(AppBanner)
// }).$mount('#app-banners');
